import { normalize } from 'normalizr';

import * as entities from './entities';

export const types = {
  ADD_OPDEFS_TO_STORE: 'opDefs/ADD_OPDEFS_TO_STORE',
  COMPILE_FORMULA_ERROR: 'opDefs/COMPILE_FORMULA_ERROR',
  COMPILE_FORMULA_REQUEST: 'opDefs/COMPILE_FORMULA_REQUEST',
  COMPILE_FORMULA_SUCCESS: 'opDefs/COMPILE_FORMULA_SUCCESS',
  FETCH_MACHINES_ERROR: 'opDefs/FETCH_MACHINES_ERROR',
  FETCH_MACHINES_REQUEST: 'opDefs/FETCH_MACHINES_REQUEST',
  FETCH_MACHINES_SUCCESS: 'opDefs/FETCH_MACHINES_SUCCESS',
  FETCH_MANUFACTURERS_ERROR: 'opDefs/FETCH_MANUFACTURERS_ERROR',
  FETCH_MANUFACTURERS_REQUEST: 'opDefs/FETCH_MANUFACTURERS_REQUEST',
  FETCH_MANUFACTURERS_SUCCESS: 'opDefs/FETCH_MANUFACTURERS_SUCCESS',
  RECEIVE_OPDEF: 'opDefs/RECEIVE_OPDEF',
  RECEIVE_OPDEFS: 'opDefs/RECEIVE_OPDEFS',
  RECEIVE_PROCESS_CLASSES: 'opdefs/RECEIVE_PROCESS_CLASSES',
  RESET_FORMULA_MESSAGE: 'opDefs/RESET_FORMULA_MESSAGE',
  SEARCH_OP_DEFS_ERROR: 'opDefs/SEARCH_OP_DEFS_ERROR',
  SEARCH_OP_DEFS_REQUEST: 'opDefs/SEARCH_OP_DEFS_REQUEST',
  SEARCH_OP_DEFS_SUCCESS: 'opDefs/SEARCH_OP_DEFS_SUCCESS',
  UPDATE_FORMULA_ERROR: 'opDefs/UPDATE_FORMULA_ERROR',
  UPDATE_FORMULA_REQUEST: 'opDefs/UPDATE_FORMULA_REQUEST',
  UPDATE_FORMULA_SUCCESS: 'opDefs/UPDATE_FORMULA_SUCCESS',
  UPDATE_OPDEF_ERROR: 'opDefs/UPDATE_OPDEF_ERROR',
  UPDATE_OPDEF_REQUEST: 'opDefs/UPDATE_OPDEF_REQUEST',
  UPDATE_OPDEF_SUCCESS: 'opDefs/UPDATE_OPDEF_SUCCESS',
  UPDATE_VARIABLE_ERROR: 'opDefs/UPDATE_VARIABLE_ERROR',
  UPDATE_VARIABLE_REQUEST: 'opDefs/UPDATE_VARIABLE_REQUEST',
  UPDATE_VARIABLE_SUCCESS: 'opDefs/UPDATE_VARIABLE_SUCCESS',
};

export const receiveOpDef = (payload) => ({
  type: types.RECEIVE_OPDEF,
  payload: normalize(payload.opDef, entities.opDefSchema),
});

export const receiveOpDefs = (opDefs) => ({
  type: types.RECEIVE_OPDEFS,
  payload: opDefs,
});

export const receiveProcessClasses = ({ processClasses }) => ({
  type: types.RECEIVE_PROCESS_CLASSES,
  payload: normalize(processClasses, [entities.processClassSchema]),
});

export const addOpDefsToStore = (payload) => ({
  type: types.ADD_OPDEFS_TO_STORE,
  payload: normalize(payload.opDefs, [entities.opDefSchema]),
});

export const fetchManufacturers = {
  request: (payload) => ({
    type: types.FETCH_MANUFACTURERS_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.FETCH_MANUFACTURERS_SUCCESS,
    payload: normalize(
      { id: payload.processClassId, manufacturers: payload.manufacturers },
      entities.processClassManufacturerSchema,
    ),
  }),
  error: (payload) => ({
    type: types.FETCH_MANUFACTURERS_ERROR,
    payload,
  }),
};

export const fetchMachines = {
  request: (payload) => ({
    type: types.FETCH_MACHINES_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.FETCH_MACHINES_SUCCESS,
    payload: normalize(
      {
        id: `${payload.processClassId}_${payload.manufacturerId}`,
        machines: payload.machines,
      },
      entities.processClassManufacturerMachineSchema,
    ),
  }),
  error: (payload) => ({
    type: types.FETCH_MACHINES_ERROR,
    payload,
  }),
};

export const updateOpDef = {
  request: (opDefId, data) => ({
    type: types.UPDATE_OPDEF_REQUEST,
    payload: { opDefId, data },
  }),
  success: (payload) => ({
    type: types.UPDATE_OPDEF_SUCCESS,
    payload: normalize(payload, entities.opDefSchema),
  }),
  error: (error) => ({
    type: types.UPDATE_OPDEF_ERROR,
    payload: error,
  }),
};

export const updateVariable = {
  request: ({ variableId, data }) => ({
    type: types.UPDATE_VARIABLE_REQUEST,
    payload: { variableId, data },
  }),
  success: (payload) => ({
    type: types.UPDATE_VARIABLE_SUCCESS,
    payload: normalize(payload, entities.variableSchema),
  }),
  error: (error) => ({
    type: types.UPDATE_VARIABLE_ERROR,
    payload: error,
  }),
};

export const updateFormula = {
  request: ({ itemId, formula, revertedFrom }) => {
    return {
      type: types.UPDATE_FORMULA_REQUEST,
      payload: { opDefId: itemId, formula, revertedFrom },
    };
  },
  success: (opDefId, formula) => {
    const normalized = normalize(formula.variables, [entities.variableSchema]);
    return {
      type: types.UPDATE_FORMULA_SUCCESS,
      payload: {
        entities: {
          variables: normalized.entities.variables,
        },
        formula: {
          ...formula,
          variables: normalized.result,
        },
        opDefId,
      },
    };
  },
  error: (error) => ({
    type: types.UPDATE_FORMULA_ERROR,
    payload: error,
  }),
};

export const compileFormula = {
  request: ({ formula }) => ({
    type: types.COMPILE_FORMULA_REQUEST,
    payload: { formula, version: 'v2' },
  }),
  success: () => ({
    type: types.COMPILE_FORMULA_SUCCESS,
  }),
  error: (error) => ({
    type: types.COMPILE_FORMULA_ERROR,
    payload: error,
  }),
};

export const resetFormulaMessage = () => ({
  type: types.RESET_FORMULA_MESSAGE,
});

export const searchOpDefs = {
  request: (payload) => ({
    type: types.SEARCH_OP_DEFS_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.SEARCH_OP_DEFS_SUCCESS,
    payload: normalize(payload, [entities.opDefSchema]),
  }),
  error: () => ({
    type: types.SEARCH_OP_DEFS_ERROR,
  }),
};
